import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loadingShow: false,
    routerViewShow: false,
    getLocationNum: localStorage.getItem('getLocationNum')
      ? localStorage.getItem('getLocationNum')
      : 1,
    senderInfo: null || JSON.parse(localStorage.getItem('senderInfo')), // 当前寄件人信息
    addresseeInfo: null || JSON.parse(localStorage.getItem('addresseeInfo')), // 当前收件人信息
    selectedService:
      null || JSON.parse(localStorage.getItem('selectedService')), // 选择的站点
    selectedExpress:
      null || JSON.parse(localStorage.getItem('selectedExpress')), // 选择的快递信息
    defaultAddress: null || JSON.parse(localStorage.getItem('defaultAddress')), // 寄件人默认地址
    selectedAddress: 0 || localStorage.getItem('selectedAddress'), // 选择的站点索引
    goodsMessage: '' || localStorage.getItem('goodsMessage'),
    remark: null || JSON.parse(localStorage.getItem('remark')),
    payInfo: null || JSON.parse(localStorage.getItem('payInfo')),
    cancelTokenArr: []
  },
  mutations: {
    showLoading(state) {
      state.loadingShow = true
    },
    hideLoading(state) {
      state.loadingShow = false
    },
    set_senderInfo(state, obj) {
      state.senderInfo = obj
      localStorage.setItem('senderInfo', JSON.stringify(obj))
    },
    set_addresseeInfo(state, obj) {
      state.addresseeInfo = obj
      localStorage.setItem('addresseeInfo', JSON.stringify(obj))
    },
    clearInfo(state) {
      state.getLocationNum = 1
      state.senderInfo = null // 当前寄件人信息
      state.addresseeInfo = null // 当前收件人信息
      state.selectedService = null // 选择的站点
      state.selectedExpress = null // 选择的快递信息
      state.selectedAddress = 0 // 选择的站点索引
      state.goodsMessage = ''
      state.remark = null
      state.payInfo = null
      let location = localStorage.getItem('location')
      let userInfo = localStorage.getItem('userInfo')
      localStorage.clear()
      localStorage.setItem('location', location)
      localStorage.setItem('userInfo', userInfo)
    },
    set_selectedService(state, obj) {
      state.selectedService = obj
      localStorage.setItem('selectedService', JSON.stringify(obj))
    },
    set_selectedExpress(state, obj) {
      state.selectedExpress = obj
      localStorage.setItem('selectedExpress', JSON.stringify(obj))
    },
    set_defaultAddress(state, obj) {
      state.defaultAddress = obj
      localStorage.setItem('defaultAddress', JSON.stringify(obj))
    },
    set_goodsMessage(state, str) {
      state.goodsMessage = str
      localStorage.setItem('goodsMessage', str)
    },
    set_remark(state, obj) {
      state.remark = obj
      localStorage.setItem('remark', JSON.stringify(obj))
    },
    set_selectedAddress(state, value) {
      state.selectedAddress = value
      localStorage.setItem('selectedAddress', value)
      // alert(state.selectedAddress)
    },
    set_payInfo(state, obj) {
      state.payInfo = obj
      localStorage.setItem('payInfo', JSON.stringify(obj))
    },
    set_routerViewShow(state, str) {
      state.routerViewShow = str
      // localStorage.setItem('routerViewShow', str)
    },
    set_getLocationNum(state) {
      state.getLocationNum++
      localStorage.setItem('getLocationNum', state.getLocationNum)
    },
    pushToken: (state, src) => {
      state.cancelTokenArr.push(src.cancelToken)
    },
    clearToken: ({ cancelTokenArr }) => {
      cancelTokenArr.forEach(item => {
        item('路由跳转取消请求')
      })
      cancelTokenArr = []
    }
  },
  actions: {},
  modules: {}
})
